// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__2YJKb","label":"style_label__1P2pk"};